import { ReactTouchMoveLimitValidator } from './touch-move-validator';

/**
 * 判断 ipad pencil 是否触发 click
 * 因为 pencil 点击很容易触发 touchmove，导致不会触发 click 事件
 * 这里对 move 加一些容错值，手动判断是否符合点击逻辑
 */
export default class IpadPencilClickHelper {
    private isMove = false;
    private touchMoveLimitValidator = new ReactTouchMoveLimitValidator();
    private clickHandler: () => void;

    public constructor(clickHandler: () => void) {
        this.clickHandler = clickHandler;
    }
    public touchstart = (event: React.TouchEvent) => {
        if (!this.isIpadPencilTouch(event)) {
            return;
        }
        this.isMove = false;
        this.touchMoveLimitValidator.touchStart(event);
    };

    public touchmove = (event: React.TouchEvent) => {
        if (!this.isIpadPencilTouch(event)) {
            return;
        }
        if (this.touchMoveLimitValidator.isMoveValid(event)) {
            this.isMove = true;
        }
    };

    public touchend = (event: React.TouchEvent) => {
        if (!this.isIpadPencilTouch(event)) {
            return;
        }
        if (this.isMove) {
            this.isMove = false;
            return;
        }
        this.clickHandler?.();
    };

    private getFirstTouch = (event: React.TouchEvent): React.Touch | null => {
        if (event.changedTouches?.length) {
            return event.changedTouches[0];
        }
        if (event.touches?.length) {
            return event.touches[0];
        }
        return null;
    };

    /**
     * 判断当前 touch 事件是不是由触摸笔触发的
     * touchType 是一个兼容性比较差的属性，不过在 apple pencil 中支持
     * @param event
     * @returns
     */
    private isIpadPencilTouch = (event: React.TouchEvent) => {
        const touch = this.getFirstTouch(event);
        if (!touch) {
            return;
        }
        return (touch as any).touchType === 'stylus';
    };
}
